export default __webpack_public_path__ + "901229d3c4877d0fb6bc5d92fa897864.svg";